module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WATER_ELEMENTAL_STYLE.802bf422.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WATER_ELEMENTAL_STYLE.png
// module id = 1313
// module chunks = 16